<template>
  <ListQuestions :client_name="client_name" :question_types="question_types" />
</template>
<script>
import ListQuestions from "@/components/questionnaire/ListQuestions.vue";

import axios from "axios";
import $ from "jquery";

export default {
  name: "MIDQuestionnaires",
  components: { ListQuestions },

  data() {
    return {
      client_name: "MID",
       question_types: [
        { label: "Multi choice", value: "multichoice" },
        { label: "One choice", value: "onechoice" },
        { label: "Text", value: "text" },
      ],
    };
  },
  computed: {},
  watch() {},
  mounted() {},
  created() {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/Questionnaire.vue